import React from "react";
import HeadingWithWatermark from "../HeadingWithWatermark";

const officeBearers = [
  {
    name: "H.E. Prof. (Dr.) K. C. Jankee",
    role: "President WASME , Ambassador of Mauritius to Russia ",
    image: "/img/k-c-jankee.png",
  },
  {
    name: "Mr. Dumisani J. Msibi",
    role: "Vice President WASME , Group Managing Director, FINCORP, Swaziland",
    image: "/img/Misibi.jpg",
  },
  {
    name: "Dr. Friday Okpara",
    role: "Vice President WASME , Director,Small and Medium Enterprise Development Agency(SMEDAN),Nigeria",
    image: "/img/friday.jpg",
  },
  {
    name: "Mr. Rajesh Kazi Shrestha ",
    role: "Vice President WASME , Chairperson, Advisory Council of Nepal Chamber of Commerce",
    image: "/img/Mr.Rajesh_Kazi .png",
  },
  {
    name: "Mr. S M Zillur Rahman",
    role: "Vice President WASME , Chairman & CEO, RAHMAN GROUP Bangladesh  ",
    image: "/img/zillur.jpg",
  },
];

const OfficeBearers = () => {
  return (
    <section className="py-20 bg-gradient-to-br from-[#f4f8fb] to-white">
      <div className="max-w-7xl mx-auto px-6">

        <HeadingWithWatermark
          title="Governing Body"
          watermarkText="Leadership"
          color="#1b73a7"
          align="center"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-10 mt-16">
          {officeBearers.map((person, i) => (
            <div
              key={i}
              className="group bg-white/80 backdrop-blur-xl rounded-2xl shadow-md hover:shadow-2xl transition-all duration-300 p-6 text-center relative"
            >
              {/* Gradient ring */}
              <div className="absolute inset-0 rounded-2xl bg-gradient-to-br from-[#1b73a7] to-transparent opacity-0 group-hover:opacity-10 transition" />

              {/* Image */}
              <div className="relative mx-auto w-36 h-36 rounded-full p-[3px] bg-gradient-to-br from-[#1b73a7] to-[#9ad0f5]">
                <img
                  src={person.image}
                  alt={person.name}
                  className="w-full h-full object-cover rounded-full bg-white"
                />
              </div>

              {/* Name */}
              <h3 className="mt-6 text-lg font-semibold text-gray-900 group-hover:text-[#1b73a7] transition">
                {person.name}
              </h3>

              {/* Role */}
              <p className="text-sm text-gray-600 mt-1">
                {person.role}
              </p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default OfficeBearers;
